import {LoginPage} from 'modules/Auth';

export default LoginPage;
